export var formatAcademyImage = function formatAcademyImage(imageURL) {
  if (!imageURL.startsWith('https:')) {
    return "https://s3.amazonaws.com/public-catalog.crehana.com/".concat(imageURL);
  }
  return imageURL;
};